import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { marked } from 'marked'

/*
 * pass a text from a translation result - it can contain markdown syntax
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'CCustomerService',
  props: {
    text: {}
  },
  emits: ['customer'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

function md(text: string) {
  return marked(text)
}
function clickHandler(e: Event) {
  const event: any = e

  if (event.target && event.target.tagName === 'A') {
    if (event.target.href && /#customer/.test(event.target.href)) {
      emit('customer')
    }
  }
  e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: "customer-service t-text",
    onClick: clickHandler,
    "data-qe-id": "customer-service-panel"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "testimonial" }, null, -1)),
    _createVNode(_component_t_text, {
      class: "content",
      innerHTML: md(_ctx.text)
    }, null, 8, ["innerHTML"])
  ]))
}
}

})